// extracted by mini-css-extract-plugin
module.exports = {"videoWrapper":"VideoPlayer_videoWrapper__15NcF","playpause":"VideoPlayer_playpause__3n2KC","preview":"VideoPlayer_preview__3fXKa"};